<template>
  <v-tooltip bottom :allow-overflow="true">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon @click.prevent="downloadAttachment">
        <v-icon size="22">icon-pdf</v-icon>
      </v-btn>
    </template>
    <span>Download</span>
  </v-tooltip>
</template>

<script>
  import api from '@/api/api';
  import methods from '@/utils/methods';

  export default {
    name: 'EboksAttachment',
    props: {
      attachmentId: {
        type: Number,
        required: true,
      },
      attachmentType: {
        type: Number,
        required: true,
      },
      visitId: {
        type: Number,
        required: true,
      },
    },
    methods: {
      downloadAttachment: function () {
        methods.downloadURL(api.eboksAttachmentFileUrl(this.visitId, this.attachmentType, this.attachmentId));
      },
    },
  };
</script>
